var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 34.52,
    x2: 314.71,
    y1: 262.85,
    y2: 262.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeMiterlimit: 10,
    strokeWidth: 17.5,
    d: "M174.1 241.62V280H34.52m139.58-43v43h140.61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcbec0",
    fillRule: "evenodd",
    d: "M279.84 165.27L256.38 89.1a10.9 10.9 0 0 0-9.81-7.23H103.44a10.86 10.86 0 0 0-9.81 7.23l-23.46 76.17a2.62 2.62 0 0 0 2.65 3.63h18.94v83.23h166.49V168.9h18.94a2.65 2.65 0 0 0 2.65-3.63zm-96 44.17v12.31h-17.46v-12.31c-11.18-1.74-20.63-7.21-26-15.17L153 183.08c6.09 7.09 13.92 9.95 22.25 9.95 10.32 0 15.17-2.24 15.17-8.83 0-5.59-3-8.08-19.4-11.81-16-3.73-27.22-8.82-27.22-26 0-13 9.57-21.63 22.62-24.12v-12.41h17.41v12.56c9.2 1.74 16.41 6.21 22.75 12.8L194 147.41c-5.59-5.72-11.81-8.95-19.76-8.95-9.33 0-12.44 3.35-12.44 7.21 0 5.47 3.73 7.21 17.53 10.44s29.07 7.95 29.07 26.89c0 14.13-7.58 23.83-24.61 26.44z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineicon);
export default __webpack_public_path__ + "static/media/onlineicon.e96af478db4958716d5dea0e60910682.svg";
export { ForwardRef as ReactComponent };